<Cell {header} {priority} type="learning-objective" {colspan} {rowspan}>
    <span slot="header">{text}</span>
    <div slot="data">
        <div
            tabindex={selectable ? undefined : 0}
            class="prom-cell__lo-title prom-cell__lo-title--{cssClass.toLowerCase()}"
            role="button"
            on:keypress={keyPress}
        >
            {#if renderLoTitleHtml}
                <span>{@html title}</span>
            {:else}
                <span>{title}</span>
            {/if}
        </div>
        {#if description}
            {#if renderLoDescriptionHtml}
                <p class="prom-cell__lo-description">{@html description}</p>
            {:else}
                <p class="prom-cell__lo-description">{description}</p>
            {/if}
        {/if}
    </div>
</Cell>

<script>
    import Cell from '../../Cell/v1/Cell.svelte';
    import { Keys } from '@itslearning/atlas/keyboard/keys';
    import { normalizeKey } from '@itslearning/atlas/keyboard/normalize';
    import { createEventDispatcher } from 'svelte';

    const dispatch = createEventDispatcher();

    /** @type {string} */
    export let text = '';
    /** @type {string} */
    export let title = '';
     /** @type {boolean} */
    export let renderLoTitleHtml = false;
    /** @type {string} */
    export let description = '';
    /** @type {boolean} */
    export let renderLoDescriptionHtml = false;
    /** @type {boolean} */
    export let header = false;
    /** @type {boolean} */
    export let selectable = false;
    /** @type {string} */
    export let cssClass = '';
    /** @type {1|2|3} */
    export let priority = 1;
    /** @type {number} */
    export let colspan = 1;
    /** @type {number} */
    export let rowspan = 1;

    function keyPress(event) {
        switch (normalizeKey(event.key)) {
            case Keys.ENTER:
            case Keys.SPACE:
                dispatch('click', event);
                break;
            default:
                return;
        }
    }
</script>
